import { createStore, combineReducers } from 'redux'

import formReducer from './features/form.reducer'
import keycloakReducer from './features/keycloak.reducer'

export const sessionStorageStateKey = 'appState'

const previousState = sessionStorage.getItem(sessionStorageStateKey)

export const cacheAppState = () => {
  sessionStorage.setItem(
    sessionStorageStateKey,
    JSON.stringify(store.getState())
  )
}

/* eslint-disable no-underscore-dangle */
const store = createStore(
  combineReducers({
    form: formReducer,
    keycloak: keycloakReducer,
  }),
  previousState ? JSON.parse(previousState) : undefined,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)
/* eslint-enable */

export { store }
